/* eslint-disable graphql/template-strings -- REST-backed queries use @rest directives that don't match the GraphQL schema */
import gql from 'graphql-tag';

export const SlackMyAccountsQuery = gql`
  query SlackMyAccountQueryCds {
    SlackAuthV1Resource(input: {})
      @rest(type: "SlackAuthV1Resource", path: "slackAuth.v1?q=me&fields=email,status", method: "GET") {
      elements @type(name: "SlackAccount") {
        id
        email
        status
        degreeId
      }
    }
  }
`;

export const ExternalSlackTeamInformationQuery = gql`
  query ExternalSlackTeamInformationQueryCds($ids: String!) {
    ExternalSlackTeamInformationV1Resource(ids: $ids)
      @rest(
        type: "ExternalSlackTeamInformationV1Resource"
        path: "externalSlackTeamInformation.v1?q=byDegreeIds&ids={args.ids}&fields=slackTeam,degreeId"
        method: "GET"
      ) {
      elements @type(name: "ExternalSlackTeamInformation") {
        id
        slackTeam
        degreeId
      }
    }
  }
`;
